import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/macro-calculator',
  component: () => import('../../routes/MacroCalculator.svelte'),
  card: {
    id: 'macro-calculator',
    title: 'Macro Calculator',
    description: 'Calculate your daily macronutrient targets based on your BMR, activity level, and fitness goals.',
    icon: 'nutrition',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/macro-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Macro Calculator – Daily Macronutrient Targets for Your Fitness Goals',
    description: 'Free macro calculator using the Mifflin-St Jeor equation. Calculate your daily calories and break down protein, carbs, and fat grams based on your weight loss, maintenance, or muscle gain goals.',
  },
};

export default meta;
